import React, { useState, useEffect } from "react";
import PersonalProfileView from "./PersonalProfileView";
import ProfessionalProfileView from "./ProfessionalProfileView";
import {
  useParams,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import SideFeedParent from "../MyProfileDetails/SideFeedParent";
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import useApi from "../../Utilities/useAPI";
import CryptoJS from "crypto-js";
import {
  transformAwardsData,
  transformCertificateData,
  transformEducationData,
  transformExperienceData,
  transformProjectData,
} from "../MyProfileDetails/ParentProfile";
import loaderGif from "../../../Assets/img/icons/Animation - 1718370478484.gif";
import UserConnectFullViewSkeleton from "../../LoadingSkeleton/UserConnectFullViewSkeleton";
import { useUserDetailContext } from "../../UserDetailContext";
import { useQuantityContext } from "../../QuantityContext";
import NEOIN_LOGO from "../../../Assets/img/Neoin-logo.png";

const ParentProfile = () => {
  const { callApiFunction } = useApi();

  const { profileType } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("encryptedId");
  const navigate = useNavigate();

  const bytes = CryptoJS.AES.decrypt(
    decodeURIComponent(userId),
    "UserDetailsSecretKey"
  );
  const refId = bytes.toString(CryptoJS.enc.Utf8);
  console.log("123456Neel",refId, searchParams)
  // const id = bytes.toString(CryptoJS.enc.Utf8);
  const { handleSuccess, handleFailure, handleInfo } = useQuantityContext();
  const [usertoken, setUserToken] = useState("");
  const [availableHeight1, mainAreaRef] = useAvailableHeight(138);
  const [availableHeight2, sideFeedRef] = useAvailableHeight(138);
  const { userDetails } = useUserDetailContext();

  const [recommendations, setRecommendations] = useState([]);

  const [cardsWithAccess, setCardsWithAccess] = useState([]);
  const apiKey = process.env.REACT_APP_API_KEY;
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    "user-key": decodeURIComponent(userId),
  };

  const objectId = localStorage.getItem("objectId");

  const new_headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  // const connectionCountHeaders = {
  //   ...headers,
  //   Authorization: `Bearer ${objectId}`
  // }
  const [isLoading, setIsLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState("");
  const [link, setLink] = useState("");
  const handleMenuClick = (event, newValue) => {
    setActiveMenu(newValue);
  };

  const encryptText = (userRefId) => {
    const encryptedId = CryptoJS.AES.encrypt(
      userRefId.toString(),
      "UserDetailsSecretKey"
    ).toString();
    return encryptedId;
  };

  const renderTooltipText = (cardType) => {
    return `Get Consent for this user's ${cardType} Card to view their ${cardType} Profile`;
  };

  const maskPhone = (phone = "") => {
    if (!phone) return "";
    return phone.replace(/(\d{2})\d+(\d{2})/, "$1******$2");
  };

  const maskEmail = (email = "") => {
    if (!email) return "";
    const [name, domain] = email.split("@");
    if (!name || !domain) return email;
    return name.slice(0, 2) + "******@" + domain;
  };

  const maskDOB = (dob = "") => {
    if (!dob) return "";
    return dob.slice(0, 4) + "-**-**";
  };

  // let activeProfile = ''
  // if(profileType === 'Personal') {
  //   activeProfile = 'personal_profile';
  // }
  // else if(profileType === 'Professional') {
  //   activeProfile = 'professional_profile';
  // }

  // States for displaying Info
  const [personalData, setPersonalData] = useState({
    aboutMe: "",
    userRefId: "",
    encryptedId: userId,
    profilePic: "",
    coverPic: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    nickName: "",
    personalEmail: "",
    phoneNumber: "",
    gender: "",
    maritalStatus: "",
    personAddress: "",
    isFieldPublic: {
      dateOfBirth: true,
      nickName: true,
      personalEmail: true,
      phoneNumber: true,
      gender: true,
      maritalStatus: true,
      personAddress: true,
    },
    hobbies: [],
    personalLanguages: [],
    isSectionPublic: {
      aboutMe: true,
      hobbies: true,
      personalLanguages: true,
    },
  });
  const [healthData, setHealthData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [professionalData, setProfessionalData] = useState({
    aboutMe: "",
    profilePic: "",
    userRefId: "",
    encryptedId: userId,
    coverPic: "",
    companyLogo: "",
    designation: "",
    department: "",
    companyName: "",
    companyWebsite: "",
    companyEmail: "",
    companyAddress: "",
    companyPhone: "",
    startDate: "",
    endDate: "",
    isCurrentlyWorking: "",
    isVerified: {
      companyEmail: false,
      companyPhone: false,
    },
    isFieldVisible: {
      companyName: false,
      companyWebsite: false,
      designation: false,
      department: false,
      companyEmail: false,
      companyPhone: false,
      companyAddress: false,
      aboutMe: false,
    },
    softSkills: {
      isPublic: false,
      skills: [],
    },
    profSkills: {
      isPublic: false,
      skills: [],
    },
    profTools: {
      isPublic: false,
      skills: [],
    },
  });
  const [services, setServices] = useState({
    id: "",
    serviceList: [],
    servicesDetails: "",
    workLocation: "",
    remote: "",
    dayStart: "",
    dayEnd: "",
    workStart: "",
    workEnd: "",
    currency: "",
    hourRate: "",
    serviceAttachments: [],
  });
  const [projectList, setProjectList] = useState([]);
  const [awardsList, setAwardsList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [experienceList, setExperienceList] = useState([]);
  const [resumeData, setResumeData] = useState({});
  const [videoResumeData, setVideoResumeData] = useState({});
  const [connectionCount, setConnectionCount] = useState(0);
  const [accessibleCards, setAccessibleCards] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);
  const [profileData, setProfileData] = useState(null);
  const [profileAlert, setProfileAlert] = useState(false);
  // API Calling Functions

  const getPersonalData = async () => {
    const endpoint = `${process.env.REACT_APP_BACKEND_URL}/userprofile/other/personal_profile`;
    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: headers,
      });
      const responseObject = await response.json();
      // console.log('response:', response,'responseData:', responseData, );
      const personalInfo = responseObject.data.personal_info;
      const languageInfo = responseObject.data.language_info;
      const hobbiesInfo = responseObject.data.hobbies_info;
      const defaultProfilePic = responseObject.data?.profile_pic || "";
      setPersonalData({
        aboutMe: personalInfo.about_me,
        profilePic:
          (personalInfo?.user_profile_url
            ? personalInfo?.user_profile_url
            : defaultProfilePic) || "",
        coverPic: personalInfo.user_cover_url,
        firstName: personalInfo.first_name,
        lastName: personalInfo.last_name,
        userRefId: personalInfo.user_ref_id,
        encryptedId: userId,
        dateOfBirth: personalInfo.dob,
        nickName: personalInfo.nick_name,
        personalEmail: personalInfo.personal_email,
        phoneNumber: personalInfo.phone_no,
        gender: personalInfo.gender,
        maritalStatus: personalInfo.marital_status,
        personAddress: personalInfo.address,
        isFieldPublic: {
          dateOfBirth: personalInfo.is_dob_public,
          nickName: personalInfo.is_nickname_public,
          personalEmail: personalInfo.is_personal_email_public,
          phoneNumber: personalInfo.is_phoneno_public,
          gender: personalInfo.is_gender_public,
          maritalStatus: personalInfo.is_marital_public,
          personAddress: personalInfo.is_address_public,
        },
        hobbies: JSON.parse(hobbiesInfo.hobbies_info || "[]"), // Assuming hobbies will be added later
        personalLanguages: JSON.parse(languageInfo.language_info || "[]"), // Assuming languages will be added later
        isSectionPublic: {
          aboutMe: personalInfo.is_about_public,
          hobbies:
            Object.keys(hobbiesInfo).length === 0 ||
            hobbiesInfo.is_public === false
              ? false
              : true, // Assuming the default value for hobbies is true
          personalLanguages:
            Object.keys(languageInfo).length === 0 ||
            languageInfo.is_public === false
              ? false
              : true, // Assuming the default value for languages is true
        },
      });
      setHealthData(responseObject.data.health_info);
      setFamilyData(responseObject.data.family_info);
    } catch (error) {
      console.log("Error fetching Personal Profile data:", error);
    }
  };

  const getProfessionalData = async () => {
    const endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/other/professional_profile`;
    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: headers,
      });
      const responseObject = await response.json();
      if (responseObject.status === "SUCCESS") {
        const profileInfo = responseObject.data?.personalInfo || {};
        const softSkillsInfo = responseObject.data?.skills?.soft_skills || {};
        const profSkillsInfo =
          responseObject.data?.skills?.professional_skills || {};
        const profToolsInfo =
          responseObject.data?.skills?.professional_tools || {};
        const servicesInfo = responseObject.data?.services[0] || {};
        const projectsInfo = responseObject.data?.projects || [];
        const awardsInfo = responseObject.data?.awards || [];
        const educationInfo = responseObject.data?.education || [];
        const certificateInfo = responseObject.data?.certificates || [];
        const experienceInfo = responseObject.data?.experiences || [];
        const resumeInfo = responseObject.data?.resume || [];
        const videoResumeInfo = responseObject.data?.video_resume || [];
        const defaultProfilePic = responseObject.data?.profile_pic || "";
        const recommendation = responseObject.data?.recommendations || [];

        setProfessionalData({
          firstName: profileInfo.first_name,
          lastName: profileInfo.last_name,
          userRefId: profileInfo.user_ref_id,
          encryptedId: userId,
          accessToken: responseObject.data?.accessToken,
          aboutMe: profileInfo.about_me || "",
          profilePic:
            (profileInfo?.user_profile_url
              ? profileInfo?.user_profile_url
              : defaultProfilePic) || "",
          coverPic: profileInfo.user_cover_url || "",
          designation: profileInfo.designation || "",
          department: profileInfo.department || "",
          companyName: profileInfo.company_name || "",
          companyWebsite: profileInfo.website || "",
          companyEmail: profileInfo.professional_email || "",
          companyAddress: profileInfo.address || "",
          companyPhone: profileInfo.phone_no,
          startDate: profileInfo.start_year,
          endDate: profileInfo.end_year,
          isCurrentlyWorking: profileInfo.is_currently_working || false,
          isFieldVisible: {
            companyName: profileInfo.is_company_visible || false,
            designation: profileInfo.is_designation_visible || false,
            department: profileInfo.is_dept_visible || false,
            companyAddress: profileInfo.is_address_public || false,
            aboutMe: profileInfo.is_about_public || false,
          },
          softSkills: {
            isPublic: softSkillsInfo.is_public || false,
            skills: softSkillsInfo.skills || [],
          },
          profSkills: {
            isPublic: profSkillsInfo.is_public || false,
            skills: profSkillsInfo.skills || [],
          },
          profTools: {
            isPublic: profToolsInfo.is_public || false,
            skills: profToolsInfo.skills || [],
          },
        });

        if (Object.keys(servicesInfo).length > 0) {
          const serviceDocs = servicesInfo?.attachments?.map((document) => ({
            id: document.id || "",
            name: document.document_name || "",
            data: document.document_url || "",
            type: document.document_type || "",
            size:
              JSON.parse(document.document_meta)?.document_size || "Unknown",
            date: new Date(document.created_at).toLocaleDateString() || "",
          }));
          setServices({
            id: servicesInfo.id,
            serviceList: JSON.parse(servicesInfo.services_info || "[]"),
            servicesDetails: servicesInfo.about_services || "",
            workLocation: servicesInfo.location || "",
            remote: servicesInfo.is_available_remote
              ? "Available for Remote Work"
              : "",
            dayStart: servicesInfo.start_day || "",
            dayEnd: servicesInfo.end_day || "",
            workStart: servicesInfo.starting_hour || "",
            workEnd: servicesInfo.ending_hour || "",
            currency: servicesInfo.currency || "",
            hourRate: servicesInfo.hourly_rate || "",
            serviceAttachments: serviceDocs || [],
          });
        } else {
          setServices({});
        }

        if (projectsInfo.length > 0) {
          const transformedProjectData = transformProjectData(projectsInfo);
          setProjectList(transformedProjectData);
        }
        if (recommendation.length > 0) {
          setRecommendations(recommendation);
        }

        if (awardsInfo.length > 0) {
          const transformedAwardsData = transformAwardsData(awardsInfo);
          setAwardsList(transformedAwardsData);
        }

        if (educationInfo.length > 0) {
          const transformedEducationData =
            transformEducationData(educationInfo);
          setEducationList(transformedEducationData);
        }

        if (certificateInfo.length > 0) {
          const transformedCertificateData =
            transformCertificateData(certificateInfo);
          setCertificateList(transformedCertificateData);
        }

        if (experienceInfo.length > 0) {
          const transformedExperienceData =
            transformExperienceData(experienceInfo);
          setExperienceList(transformedExperienceData);
        }

        if (resumeInfo.length > 0) {
          const resumeDetails = resumeInfo[0] || {};
          console.log("resumeDetails:", resumeDetails);
          setResumeData({
            id: resumeDetails.id,
            name: resumeDetails.document_name,
            type: resumeDetails.document_type,
            data: resumeDetails.document_url,
            meta: resumeDetails.document_meta,
          });
        }

        if (videoResumeInfo.length > 0) {
          const VideoResume = videoResumeInfo[0] || {};
          console.log("VideoResumeInfo:", VideoResume);
          setVideoResumeData({
            id: VideoResume.id,
            name: VideoResume?.document_name,
            type: VideoResume?.document_type,
            data: VideoResume?.document_url,
            meta: VideoResume?.document_meta,
          });
        }
      }
    } catch (error) {
      console.log("Error fetching Professional Profile data:", error);
    }
  };

  // console.log("personalData", personalData, professionalData)

  // const getRecommendations = async () => {

  //   axios
  //     .get("/mail/get-recommendations", { headers: new_headers })  // Include headers in the request
  //     .then((response) => {
  //       // console.log("respone recom", response);

  //       // Ensure the response is an array
  //       if (Array.isArray(response.data.data)) {
  //         setRecommendations(response.data.data);
  //       } else {
  //         console.error('Expected an array, but received:', response.data);
  //         setRecommendations([]); // Reset to empty array if not an array
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching recommendations:', error);
  //       setRecommendations([]); // Reset to empty array in case of error
  //     });

  // }

  const getConnectionCount = async () => {
    const endpoint = "getOthersConnectionCount";
    const reqBody = { userId: refId };
    try {
      const response = await callApiFunction(endpoint, reqBody);
      if (response.status === "SUCCESS") {
        setConnectionCount(response.connectionCount);
      }
    } catch (error) {
      console.log("Error fetching Connection Count data:", error);
    }
  };

  const getCardAccess = async () => {
    const endpoint = "fetchCardAccesssDetails";
    const reqBody = {
      ownerId: refId,
      viewerToken: objectId,
      cardNames: ["Personal", "Professional"],
    };
    try {
      const response = await callApiFunction(endpoint, reqBody);
      // console.log("parent token", response?.token);

      if (response.statusCode === 200) {
        const cardsWithAccess = response.accessResults
          .filter((card) => card.access)
          .map((card) => card.cardName);

        setAccessibleCards(cardsWithAccess);
        setLink(response?.token);

        // Set initial activeMenu based on access
        if (cardsWithAccess.includes("Personal")) {
          setActiveMenu("personal_profile");
        } else if (cardsWithAccess.includes("Professional")) {
          setActiveMenu("professional_profile");
        } else {
          setProfileAlert(true);
        }
      }
    } catch (error) {
      console.log("Error fetching Connection Count data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          getPersonalData(),
          getProfessionalData(),
          getConnectionCount(),
          getCardAccess(),
          // getRecommendations()
        ]);
        // console.log('Personal Data:', personalData);
      } catch (error) {
        console.error("Error fetching all data:", error);
      } finally {
        setIsLoading(false); // Stop the loader when all data is fetched
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="loader-container">
        <img src={loaderGif} alt="Loading..." height={100} width={100} />
      </div>
    );
  }

  const handleCheckboxChange = (cardType) => {
    setSelectedCards((prevSelectedCards) => {
      if (prevSelectedCards.includes(cardType)) {
        // Remove the card if it's already selected
        return prevSelectedCards.filter((card) => card !== cardType);
      } else {
        // Add the card if it's not selected
        return [...prevSelectedCards, cardType];
      }
    });
  };

  const handleSentConsent = async () => {
    const payload = {
      ownerId: refId,
      cardNames: selectedCards,
      viewerToken: objectId,
    };
    // console.log("PAYLOADDDD", payload);
    try {
      const response = await callApiFunction("requestCardConsent", payload);
      // console.log("helllllllllll", response.requests[0].message);
      setSelectedCards([]);
      if (response.requests[0].message === "Access request already exists.") {
        handleInfo("Consent request already exists.");
      } else {
        handleSuccess("Consent sent successfully");
      }
      setProfileAlert(false);
      navigate("/myprofile");
    } catch (error) {
      handleFailure("can't able to sent the consent", error);
      console.log("Error:", error);
    }
  };
  const handleClose = () => {
    setProfileAlert(false);
    navigate("/AllContacts_groups");
  };
  return (
    <>
      <div className="my-Profile-part">
        {accessibleCards.length > 0 ? (
          <div className="d-flex">
            <div
              className="myprofile-column-1"
              ref={mainAreaRef}
              style={
                {
                  /*maxHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none"*/
                }
              }
            >
              <div className="mt-20px menu">
                <Tabs
                  value={activeMenu}
                  onChange={handleMenuClick}
                  aria-label="Profile Tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  className="custom-profile-tabs"
                  selectionFollowsFocus
                >
                  {accessibleCards.includes("Personal") ? (
                    <Tab label="Personal Profile" value="personal_profile" />
                  ) : (
                    <>
                      <Tab
                        label="Personal Profile"
                        value="personal_profile"
                        // disabled={!accessibleCards.includes('Personal')}
                        // onClick={() => setProfileAlert(true)}
                        // Open the dialog when clicked
                        onClick={() => {
                          if (!accessibleCards.includes("Personal")) {
                            setProfileAlert(true); // Open the dialog if access is not allowed
                          }
                        }}
                      />

                      <Dialog
                        open={profileAlert}
                        // onClose={() => setProfileAlert(false)}
                      >
                        <DialogTitle>
                          You do not have consent for this action
                        </DialogTitle>
                        <hr
                          className="m-0"
                          style={{ border: "1px solid grey" }}
                        />
                        <DialogContent>
                          <div className="profile-profess-personl-consent d-flex flex-column bg-white justify-content-center bg-white">
                            <div className="d-flex align-item-center">
                              <Checkbox
                                checked={selectedCards.includes("Personal")}
                                onChange={() =>
                                  handleCheckboxChange("Personal")
                                }
                              />
                              <span className="fs-5 text-center pt-1">
                                Personal
                              </span>
                            </div>
                          </div>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            onClick={() => setProfileAlert(false)}
                            variant="outlined"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={handleSentConsent}
                            sx={{ backgroundColor: "#0044c6" }}
                            variant="contained"
                            disabled={selectedCards.length < 1} // Enable only if at least one checkbox is selected
                          >
                            Ask for Consent
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                  )}

                  {accessibleCards.includes("Professional") ? (
                    <Tab
                      label="Professional Profile"
                      value="professional_profile"
                    />
                  ) : (
                    <>
                      <Tab
                        label="Professional Profile"
                        value="Professional_profile"
                        // disabled={!accessibleCards.includes('Personal')}
                        // onClick={() => setProfileAlert(true)}
                        // Open the dialog when clicked
                        onClick={() => {
                          if (!accessibleCards.includes("Professional")) {
                            setProfileAlert(true); // Open the dialog if access is not allowed
                          }
                        }}
                      />

                      <Dialog
                        open={profileAlert}
                        // onClose={() => setProfileAlert(false)}
                      >
                        <DialogTitle>
                          You do not have consent for this action
                        </DialogTitle>
                        <hr
                          className="m-0"
                          style={{ border: "1px solid grey" }}
                        />
                        <DialogContent>
                          <div className="profile-profess-personl-consent d-flex flex-column justify-content-center bg-white">
                            <div className="d-flex align-item-center">
                              <Checkbox
                                checked={selectedCards.includes("Professional")}
                                onChange={() =>
                                  handleCheckboxChange("Professional")
                                }
                              />
                              <span className="fs-5 pt-1">Professional</span>
                            </div>
                          </div>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            onClick={() => setProfileAlert(false)}
                            variant="outlined"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={handleSentConsent}
                            sx={{ backgroundColor: "#0044c6" }}
                            variant="contained"
                            disabled={selectedCards.length < 1} // Enable only if at least one checkbox is selected
                          >
                            Ask for Consent
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                  )}
                </Tabs>
              </div>
              <div className="content-for-that-link">
                {activeMenu === "personal_profile" &&
                  accessibleCards.includes("Personal") && (
                    <>
                      <PersonalProfileView
                        personalData={personalData}
                        isSectionPublic={personalData.isSectionPublic}
                        isFieldPublic={personalData.isFieldPublic}
                        connectionCount={connectionCount}
                      />
                    </>
                  )}

                {activeMenu === "professional_profile" &&
                  accessibleCards.includes("Professional") && (
                    <>
                      <ProfessionalProfileView
                        professionalData={professionalData}
                        isFieldVisible={professionalData.isFieldVisible}
                        services={services}
                        projectList={projectList}
                        awardsList={awardsList}
                        educationList={educationList}
                        certificateList={certificateList}
                        experienceList={experienceList}
                        resumeData={resumeData}
                        videoResume={videoResumeData}
                        connectionCount={connectionCount}
                        link={link}
                        recommendations={recommendations}
                      />
                    </>
                  )}
              </div>
            </div>
            <div
              className="myprofile-column-2"
              ref={sideFeedRef}
              style={{
                /*maxHeight: `${availableHeight2}px`,*/ overflowY: "auto",
                scrollbarWidth: "none",
              }}
            >
              <SideFeedParent
                activeProfile={activeMenu}
                viewedUserId={
                  personalData.userRefId || professionalData.userRefId
                }
                encryptedId={userId}
              />
            </div>
          </div>
        ) : (
          <div className="text-center py-3">
            {/* <Dialog
              open={profileAlert}
            // onClose={() => setProfileAlert(false)}

            >
              <DialogTitle>You do not have consent for this action</DialogTitle>
              <hr className="m-0" style={{ border: '1px solid grey' }} />
              <DialogTitle className="p-0 m-0 ps-4" sx={{ fontSize: "12px" }} >Please ask for the consent...</DialogTitle>
              <DialogContent className='mb-0'>

                <div className="profile-consent d-flex flex-column bg-white">
                  <div className="d-flex align-item-center">
                    <Checkbox
                      checked={selectedCards.includes('Personal')}
                      onChange={() => handleCheckboxChange('Personal')}
                    />
                    <span className='fs-5 pt-1'>Personal</span>
                  </div>
                  <div className="d-flex align-item-center">
                    <Checkbox
                      checked={selectedCards.includes('Professional')}
                      onChange={() => handleCheckboxChange('Professional')}
                    />
                    <span className='fs-5 pt-1'>Professional</span>
                  </div>
                </div>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
                <Button onClick={handleSentConsent} sx={{ backgroundColor: "#0044c6" }} variant="contained"
                  disabled={selectedCards.length < 1}
                >
                  Ask for Consent
                </Button>
              </DialogActions>
            </Dialog> */}
            <Dialog open={profileAlert} maxWidth="md">
              <DialogTitle>You do not have consent for this action</DialogTitle>
              <hr className="m-0" style={{ border: "1px solid grey" }} />
              <DialogTitle sx={{ fontSize: "12px" }}>
                Please ask for consent from{" "}
                <strong>{`${personalData?.firstName} ${personalData?.lastName}`}</strong>{" "}
                to view their Profile.
              </DialogTitle>
              <DialogContent>
                <div className="profile-consent bg-white p-4">
                  {/* Cards Row */}
                  <div className="d-flex justify-content-center gap-5 mb-4">
                    {/* Personal Card */}
                    <div
                      className="official-card position-relative"
                      style={{
                        width: "300px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Card Header */}
                      <div
                        className="card-header p-3"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderBottom: "2px solid #0044c6",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <img src={NEOIN_LOGO} alt="" />
                          <div>
                            <div
                              className="company-name fw-bold"
                              style={{ color: "#333", fontSize: "16px" }}
                            >
                              Personal
                            </div>
                            <div
                              className="card-type"
                              style={{ color: "#666", fontSize: "12px" }}
                            >
                              Personal Card
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Card Body */}
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-4">
                          <img
                            src={personalData?.profilePic}
                            alt="Personal"
                            style={{
                              width: "80px",
                              height: "80px",
                              borderRadius: "8px",
                              objectFit: "cover",
                              border: "2px solid #f0f0f0",
                            }}
                          />
                          <div className="ms-3">
                            <div
                              className="user-name fw-bold fs-5"
                              style={{ color: "#333" }}
                            >
                              {personalData?.firstName} {personalData?.lastName}
                            </div>
                            <div
                              className="user-title"
                              style={{ color: "#666", fontSize: "14px" }}
                            >
                              Personal card
                            </div>
                          </div>
                        </div>

                        <div className="card-details">
                          <div className="detail-row d-flex mb-2">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              Phone:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {maskPhone(
                                personalData?.phoneNumber || "Not specified"
                              )}
                            </div>
                          </div>
                          <div className="detail-row d-flex mb-2">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              Email:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {maskEmail(
                                personalData?.personalEmail || "Not specified"
                              )}
                            </div>
                          </div>
                          <div className="detail-row d-flex mb-2">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              DOB:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {maskDOB(
                                personalData?.dateOfBirth || "Not specified"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Card Footer */}
                      <div
                        className="card-footer p-2 text-center"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderTop: "1px solid #e0e0e0",
                          fontSize: "10px",
                          color: "#666",
                          letterSpacing: "1px",
                        }}
                      >
                        PERSONAL CARD
                      </div>
                    </div>

                    {/* Professional Card */}
                    <div
                      className="official-card position-relative"
                      style={{
                        width: "300px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Card Header */}
                      <div
                        className="card-header p-3"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderBottom: "2px solid #28a745",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <img src={NEOIN_LOGO} alt="" />
                          <div>
                            <div
                              className="company-name fw-bold"
                              style={{ color: "#333", fontSize: "16px" }}
                            >
                              {personalData.companyName || "Not specified"}
                            </div>
                            <div
                              className="card-type"
                              style={{ color: "#666", fontSize: "12px" }}
                            >
                              Professional Card
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Card Body */}
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-4">
                          <img
                            src={professionalData.profilePic}
                            alt="Professional"
                            style={{
                              width: "80px",
                              height: "80px",
                              borderRadius: "8px",
                              objectFit: "cover",
                              border: "2px solid #f0f0f0",
                            }}
                          />
                          <div className="ms-3">
                            <div
                              className="user-name fw-bold fs-5"
                              style={{ color: "#333" }}
                            >
                              {professionalData.firstName}{" "}
                              {professionalData.lastName}
                            </div>
                            <div
                              className="user-title"
                              style={{ color: "#666", fontSize: "14px" }}
                            >
                              Professional Card
                            </div>
                          </div>
                        </div>

                        <div className="card-details">
                          <div className="detail-row d-flex mb-2">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              Department:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {professionalData?.department || "Not specified"}
                            </div>
                          </div>
                          <div className="detail-row d-flex mb-2">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              Company:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {professionalData?.companyName || "Not specified"}
                            </div>
                          </div>
                          <div className="detail-row d-flex">
                            <div
                              style={{
                                width: "100px",
                                color: "#666",
                                fontSize: "12px",
                              }}
                            >
                              Role:
                            </div>
                            <div style={{ color: "#333", fontSize: "12px" }}>
                              {professionalData?.designation || "Not specified"}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Card Footer */}
                      <div
                        className="card-footer p-2 text-center"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderTop: "1px solid #e0e0e0",
                          fontSize: "10px",
                          color: "#666",
                          letterSpacing: "1px",
                        }}
                      >
                        PROFESSIONAL CARD
                      </div>
                    </div>
                  </div>

                  {/* Checkbox Section */}
                  <div className="consent-checkboxes d-flex justify-content-center gap-5 mt-4">
                    <div
                      className="checkbox-item d-flex align-items-center"
                      style={{ width: "300px" }}
                    >
                      <Checkbox
                        checked={selectedCards.includes("Personal")}
                        onChange={() => handleCheckboxChange("Personal")}
                        sx={{
                          "&.Mui-checked": { color: "#0044c6" },
                        }}
                      />
                      <span className="fs-5 fw-medium">Personal Consent</span>
                    </div>

                    <div
                      className="checkbox-item d-flex align-items-center"
                      style={{ width: "300px" }}
                    >
                      <Checkbox
                        checked={selectedCards.includes("Professional")}
                        onChange={() => handleCheckboxChange("Professional")}
                        sx={{
                          "&.Mui-checked": { color: "#28a745" },
                        }}
                      />
                      <span className="fs-5 fw-medium">
                        Professional Consent
                      </span>
                    </div>
                  </div>
                </div>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setProfileAlert(false)}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSentConsent}
                  sx={{ backgroundColor: "#0044c6" }}
                  variant="contained"
                  disabled={selectedCards.length < 1}
                >
                  Ask for Consent
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    </>
  );
};

export default ParentProfile;
